 <div class="offer-card-wrapper" (click)="campaignClickEvent(cardData)" [ngStyle]="{'background': cardData?.benefitType ?
 appConstants.contexualCardBg[cardData.benefitType].bgColor : appConstants.contexualCardBg.cashbackPercent.bgColor}"
 [ngClass]="showFullInfo ? 'webkit-masker':''">
     <div class="bg-icon" [ngStyle]="{'background-image': 'url(' + getIcon() + ')'}">
        <section class="blurred-overlay" *ngIf="!cardData"></section>
        <!-- <img class="image-section" src="../../../assets/images/placeholder_background_offer_card.png" alt=""> -->
        <section class="content-panel " [ngClass]="showFullInfo ? 'height-resizer':''">
            <section class="mini-heading truncate-2-lines" *ngIf="cardData?.campaignType !== 'cashback'">
                {{cardData?.campaignName}}
            </section>
            <section class="inner-content pad-left-12 {{cardData?.campaignType}}">
                <section class="central-content">
                    <div class="main-header">
                        <ng-container>
                            <div class="merchant-logo mar-right-7" *ngIf="cardData?.merchantDetails?.merchantLength == 1">
                                <img class="img-merchant" [ngStyle]="{'object-fit':(cardData.benefitImg)? 'cover' : 'fill'}" [src]="cardData.benefitImg ? cardData.benefitImg : '../../../assets/images/image-coming-soon.png'" alt="">
                            </div>
                            <div class="title" [class.large]="cardData?.campaignType == 'cashback'">
                                {{cardData?.benefitTitle}}
                            </div>
                        </ng-container>
                    </div>
                    <div class="logos flex pad-top-16" *ngIf="cardData?.merchantDetails?.merchantLength > 1">
                        <div *ngFor="let merchant of cardData?.merchantDetails?.merchantIcons"
                            class="merchant-logo mar-right-10">
                            <img [ngStyle]="{'object-fit':(merchant?.logo_url || merchant?.attributes?.item?.data?.attributes?.image_url)? 'cover' : 'fill'}"
                            [src]="merchant?.logo_url || merchant?.attributes?.item?.data?.attributes?.image_url ? merchant?.logo_url || merchant?.attributes?.item?.data?.attributes?.image_url : '../../../assets/images/placheholder_brand_image.png'" class="img-merchant">
                        </div>
                        <div class="merchant-logo-num fnt-12 f500 flex align-center justify-center"
                            *ngIf="cardData?.merchantDetails?.merchantLength > 4">
                            +{{cardData?.merchantDetails?.merchantLength - 4}}
                        </div>
                    </div>
                    <div class="icon-tray" *ngIf="false">
                        <app-poshvine-icon-tray [trayLimit]="4"></app-poshvine-icon-tray>
                    </div>

                    <div class="description pad-top-16"
                    [ngClass]="(cardData?.expDate && cardData?.tcDescription &&
                    cardData?.benefitTitle)? 'line-clamp-3':''">
                        {{cardData?.description}}
                    </div>
                    <section *ngIf = "cardData?.benefitType != 'seeAll'">
                        <div class="exp fnt-10 f400 pad-top-3">
                            <svg class="mar-right-5" width="18" height="20" viewBox="0 0 18 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path
                                    d="M11.925 16.5C11.2417 16.5 10.6667 16.2667 10.2 15.8C9.73333 15.3333 9.5 14.7583 9.5 14.075C9.5 13.3917 9.73333 12.8167 10.2 12.35C10.6667 11.8833 11.2417 11.65 11.925 11.65C12.6083 11.65 13.1833 11.8833 13.65 12.35C14.1167 12.8167 14.35 13.3917 14.35 14.075C14.35 14.7583 14.1167 15.3333 13.65 15.8C13.1833 16.2667 12.6083 16.5 11.925 16.5ZM1.5 20C1.1 20 0.75 19.85 0.45 19.55C0.15 19.25 0 18.9 0 18.5V3C0 2.6 0.15 2.25 0.45 1.95C0.75 1.65 1.1 1.5 1.5 1.5H3.125V0.8C3.125 0.566667 3.2 0.375 3.35 0.225C3.5 0.0749999 3.69167 0 3.925 0C4.15833 0 4.35417 0.0749999 4.5125 0.225C4.67083 0.375 4.75 0.566667 4.75 0.8V1.5H13.25V0.8C13.25 0.566667 13.325 0.375 13.475 0.225C13.625 0.0749999 13.8167 0 14.05 0C14.2833 0 14.4792 0.0749999 14.6375 0.225C14.7958 0.375 14.875 0.566667 14.875 0.8V1.5H16.5C16.9 1.5 17.25 1.65 17.55 1.95C17.85 2.25 18 2.6 18 3V18.5C18 18.9 17.85 19.25 17.55 19.55C17.25 19.85 16.9 20 16.5 20H1.5ZM1.5 18.5H16.5V7.75H1.5V18.5ZM1.5 6.25H16.5V3H1.5V6.25ZM1.5 6.25V3V6.25Z"
                                    fill="white" />
                            </svg>
                            <span>Expires on {{cardData?.expDate | date:'mediumDate'}}</span>
                        </div>
                        <div *ngIf="cardData?.tcDescription" class="tnc fnt-10 f400 pad-top-4">
                            <a class="underline pointer" (click)="openTncModal($event)">Terms & Conditions</a>
                        </div>
                    </section>

                </section>
            </section>

        </section>
        <section *ngIf="showFullInfo" class="cross">
          <img src="../../../assets/svg/clear_white.svg" (click)="cancelModal()">
        </section>
        <ng-container *ngIf="!showFullInfo">
          <ng-content *ngTemplateOutlet="statusCard"></ng-content>
        </ng-container>
        <section  class="bottom-section mar-top-10 pad-left-30 pad-bot-32">
          <div *ngIf="!showFullInfo" class="round-btn">
             <div class="clip" [ngStyle]="{'background': cardData?.benefitType ?
             appConstants.contexualCardBg[cardData.benefitType].solidColorDark : appConstants.contexualCardBg.cashbackPercent.solidColorDark}"></div>
          </div>
      </section>
     </div>

</div>
<div class="offer-card-stub" *ngIf="false && showFullInfo" [ngStyle]="{'background': cardData?.benefitType ?
 appConstants.contexualCardBg[cardData.benefitType].bottomColor : appConstants.contexualCardBg.cashbackPercent.bottomColor}">
  <div class="divider" *ngIf="showFullInfo" ></div>

    The cashback will be credited to your AU Bank account
</div>
<ng-container *ngIf="showFullInfo">
  <ng-content *ngTemplateOutlet="statusCard"></ng-content>
</ng-container>
<ng-template #statusCard>
  <section class="absolute flex justify-center w100 text-prop" [ngClass]="(showFullInfo)? '':'top-badge'" >
    <div *ngIf="cardData?.status !== 'no-data'" class="tag {{cardData?.status}} pad-top-2 pad-bot-2 pad-10 flex align-center f300 fnt-16">
        <img *ngIf="cardData?.status == 'claimed'"
            src="https://s3.ap-south-1.amazonaws.com/images.poshvine.com/icon/claim-tick.svg">
        <img *ngIf="cardData?.status == 'locked'"
            src="https://s3.ap-south-1.amazonaws.com/images.poshvine.com/icon/locked.svg">
        <img *ngIf="cardData?.status == 'missed'"
            src="https://s3.ap-south-1.amazonaws.com/images.poshvine.com/icon/missed.svg">
        <img *ngIf="cardData?.status == 'unlocked'"
            src="https://s3.ap-south-1.amazonaws.com/images.poshvine.com/icon/unlocked.svg">
        <img *ngIf="cardData?.status == 'results_awaited'"
            src="../../../assets/svg/result-awaited.svg">
        <span>{{label}}</span>
    </div>
</section>
</ng-template>

